module.exports = __webpack_public_path__ + "img/devices-main-desktop-light-small.bb908040.bb908040.webp";